export const KAMPUS_DEV_DOMAIN = 'kampus.local';
